import { type MutableRefObject, useEffect, useState } from "react";

const useIsVisible = <T extends Element>(ref: MutableRefObject<T | null>, cb?: () => void) => {
  const [isIntersecting, setIntersecting] = useState<boolean>(false);

  useEffect(() => {
    // Create an IntersectionObserver to observe the ref's visibility
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
      if (cb) {
        cb();
      }
    });

    if (ref.current) {
      // Start observing the element
      observer.observe(ref.current);
    }

    // Cleanup the observer when the component unmounts or ref changes
    return () => {
      observer.disconnect();
    };
  }, [ref, cb]);

  return isIntersecting;
};

export default useIsVisible;
